import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftArrow", "rightArrow"]
  static values = {
    scrollAmount: { type: Number, default: 200 }
  }

  connect() {
    if (!this.hasContainerTarget) return

    // Initial check after a short delay to ensure content is rendered
    setTimeout(() => this.updateArrowVisibility(), 100)

    // Update on scroll
    this.containerTarget.addEventListener('scroll', () => this.updateArrowVisibility())

    // Update when content changes (items added/removed)
    this.resizeObserver = new ResizeObserver(() => this.updateArrowVisibility())
    this.resizeObserver.observe(this.containerTarget)
  }

  disconnect() {
    if (this.hasContainerTarget) {
      this.containerTarget.removeEventListener('scroll', () => this.updateArrowVisibility())
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  scrollLeft() {
    this.containerTarget.scrollBy({
      left: -this.scrollAmountValue,
      behavior: "smooth"
    })
    setTimeout(() => this.updateArrowVisibility(), 300)
  }

  scrollRight() {
    this.containerTarget.scrollBy({
      left: this.scrollAmountValue,
      behavior: "smooth"
    })
    setTimeout(() => this.updateArrowVisibility(), 300)
  }

  updateArrowVisibility() {
    if (!this.hasLeftArrowTarget || !this.hasRightArrowTarget) return

    const container = this.containerTarget
    const scrollLeft = container.scrollLeft
    const scrollWidth = container.scrollWidth
    const clientWidth = container.clientWidth

    // Hide arrows if content doesn't overflow
    if (scrollWidth <= clientWidth) {
      this.leftArrowTarget.style.display = 'none'
      this.rightArrowTarget.style.display = 'none'
      return
    }

    this.leftArrowTarget.style.display = 'flex'
    this.rightArrowTarget.style.display = 'flex'

    // Hide left arrow if at the start
    if (scrollLeft <= 1) {
      this.leftArrowTarget.style.opacity = '0'
      this.leftArrowTarget.style.pointerEvents = 'none'
    } else {
      this.leftArrowTarget.style.opacity = ''
      this.leftArrowTarget.style.pointerEvents = 'auto'
    }

    // Hide right arrow if at the end
    if (scrollLeft + clientWidth >= scrollWidth - 1) {
      this.rightArrowTarget.style.opacity = '0'
      this.rightArrowTarget.style.pointerEvents = 'none'
    } else {
      this.rightArrowTarget.style.opacity = ''
      this.rightArrowTarget.style.pointerEvents = 'auto'
    }
  }
}
